import { Column, Entity } from 'typeorm'
import { SoftDeleteEntity } from '../entity'

@Entity()
export class Company extends SoftDeleteEntity<Company> {
	@Column({
		type: 'varchar',
		length: 60,
		nullable: false,
	})
	name: string

	@Column({
		type: 'varchar',
		length: 255,
		nullable: false,
	})
	email: string

	@Column({
		type: 'boolean',
		default: false,
		nullable: false,
	})
	emailVerified: boolean
}
